<script setup>
defineProps({
  regions: {
    type: Object,
    required: true,
  },
  useAllRegions: {
    type: Boolean,
    required: false,
    default: false,
  },
})
const emit = defineEmits(['change'])
const expanded = ref(true)
</script>

<template>
  <div class="region-content">
    <ul>
      <li v-for="continent of regions" :key="continent.name">
        <p class="h3">{{ continent.name }}</p>
        <ul v-if="expanded">
          <RegionsFilterItem
            v-for="region of continent.regions"
            :key="region.chipName"
            :item="region"
            :use-all-regions="useAllRegions"
            @change="emit('change')"
          />
          <RegionsFilterItemCollection
            v-if="
              continent.unspecifiedItems &&
              continent.unspecifiedItems.length > 0
            "
            :items="continent.unspecifiedItems"
            label="Other"
            @change="emit('change')"
          />
        </ul>
      </li>
    </ul>
  </div>
</template>
